"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Detail = require("./Detail");

var _Detail2 = _interopRequireDefault(_Detail);

var _Item = require("./Item");

var _Item2 = _interopRequireDefault(_Item);

var _Placeholder = require("./Placeholder");

var _Placeholder2 = _interopRequireDefault(_Placeholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Detail2.default.Item = _Item2.default;
_Detail2.default.Placeholder = _Placeholder2.default;

exports.default = _Detail2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-detail@0.0.6@@alicd/crui-detail/lib/index.js
// module id = 628
// module chunks = 0